import { useCallback, useMemo, useState } from 'react';
import { SessionCustomer } from '@cld/session-service';
import { AppId } from '../../ApplicationWrapper.types';
import { FetchStatus } from '../api.types';
import { generateFetchCustomerListForAppId } from './fetchCustomersList';

export const useGetCustomers = (appId?: AppId): UseGetCustomers => {
  const [fetchCustomersStatus, setFetchCustomersStatus] = useState<FetchStatus>(FetchStatus.Pending);
  const [customersList, setCustomersList] = useState<SessionCustomer[]>([]);
  const fetchCustomersList = useMemo(() => generateFetchCustomerListForAppId(appId), [appId]);

  const getCustomersList = useCallback(
    (searchTerm = '') => {
      const trimmedSearchTerm = searchTerm.trim();

      const fetchData = async () => {
        try {
          setFetchCustomersStatus(FetchStatus.Pending);
          const data = await fetchCustomersList(trimmedSearchTerm);
          setCustomersList(data);
          setFetchCustomersStatus(FetchStatus.Success);
        } catch (e) {
          console.error(e);
          setFetchCustomersStatus(FetchStatus.Failure);
        }
      };

      void fetchData();
    },
    [fetchCustomersList, setCustomersList]
  );
  return { getCustomersList, customersList, fetchCustomersStatus };
};

interface UseGetCustomers {
  getCustomersList: (searchTerm?: string) => void;
  customersList: SessionCustomer[];
  fetchCustomersStatus: FetchStatus;
}
